// regularSurveyGate — MandatorySurveyGate avisa a lo que envuelve si falta
// responder la encuesta obligatoria. v6.11.328: el festejo de playoffs se
// muestra encima y su botón pasa a «Completar encuesta y continuar».
// v6.11.329: lo provee MandatorySurveyGate (antes RegularSurveyBlocker), para
// la regular o la de playoffs.

import { createContext } from 'react';

export const RegularSurveyGateContext = createContext<{ pending: boolean }>({ pending: false });
